<template>
  <div class="gift relative">
    <div class="gift_main flex_a_c mb_4">
      <div
        class="gift_icon bg_contain"
        :class="{ default_gift_icon: !icon }"
        :style="{
          backgroundImage: `url(${icon || defaultIcon})`
        }"
      ></div>
      <div class="gift_ctx flex_1 ml_15">
        <div class="gift_name fs_12 mb_3">{{ name }}</div>
        <div class="gift_desc fs_12 scale08_bot van-multi-ellipsis--l2">{{ desc }}</div>
      </div>
      <template v-if="copy === false">
        <button
          v-if="!hideBtn"
          class="gift_btn"
          :class="{ btn_disabled: disabled }"
          :style="{
            backgroundColor: btnColor
          }"
          @click="handleReceive"
        >
          {{ btnText }}
        </button>
      </template>
      <template v-else>
        <button
          v-clipboard="copy"
          class="gift_btn"
          :style="{
            backgroundColor: btnColor
          }"
          @click="$emit('copyCb')"
        >
          复制
        </button>
      </template>
    </div>
    <div class="gift_condition fs_12 color_org scale08_bot" v-if="condition">
      {{ condition }}
    </div>
    <div class="gift_tag flex_center fs_12 color_white" v-if="tag">
      <span class="scale08_center">{{ tag }}</span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    icon: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: '**礼包'
    },
    desc: {
      type: String,
      default: '待配置',
    },
    btnText: {
      type: String,
      default: '领取'
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    condition: {
      type: String,
    },
    tag: {
      type: String,
    },
    hideBtn: {
      type: Boolean,
      default: false,
    },
    btnColor: {
      type: String,
      default: ''
    },
    // 复制内容
    copy: {
      type: [String, Boolean],
      default: false,
    },
  },
  data () {
    return {
      defaultIcon: 'https://static.hzwxbz3.cn/Lianyun/font_end/heziIOS/gift1.png'
    }
  },
  methods: {
    handleReceive () {
      if (!this.disabled) {
        this.$emit('receive')
      } else {
        this.$emit('disableClick')
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.gift {
  padding: 8px 12px;
  border-radius: 6px;
}
.gift_icon {
  width: 60px;
  height: 60px;
}
.gift_ctx {
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: left;
  min-width: 0; // 神秘魔法，这一行不能删
}
.gift_name {
  font-weight: 700;
}
.gift_desc {
  width: 125%;
  color: #9F7155;
  line-height: 1.25;
  padding-right: 6px;
}
.gift_btn {
  font-size: 14px;
  min-width: 70px;
  box-sizing: border-box;
  height: fit-content;
  padding: 8px 16px;
  line-height: 1;
  background-color: #FF5043;
  color: #FFFFFF;
  border-radius: 1000px;
  border: none;
}
.gift_tag {
  position: absolute;
  top: 0;
  right: 0;
  border-top-left-radius: 2px;
  border-top-right-radius: 5px;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 2px;
  background: #EFB929;
  height: 16px;
  padding: 0px 4px;
}

.default_gift_icon {
  padding: 9px;
  border-radius: 15px;
  background-color: #fef3f1;
  background-size: 64%;
  background-position: center;
}
</style>